import FilterRefinementList from '@/components/filters/FilterRefinementList'
import FilterRefinementIconList from '@/components/filters/FilterRefinementIconList'
import FilterHierarchicalMenu from '@/components/filters/FilterHierarchicalMenu'

export default function FilterModalComponents({ filters }) {
  if (!filters?.length) {
    return null
  }

  const renderComponents = filters.map(({ heading, attribute, attributes, type }) => {
    const isRadio = type === 'hierarchicalMenu' || false

    if (type === 'refinementIconList') {
      return (
        <FilterRefinementIconList
          key={heading}
          heading={heading}
          attribute={attribute}
          radio={isRadio}
        />
      )
    }

    if (type === 'hierarchicalMenu') {
      return <FilterHierarchicalMenu key={heading} heading={heading} attributes={attributes} />
    }

    return <FilterRefinementList key={heading} heading={heading} attribute={attribute} />
  })

  return <div className="mx-[-1px] flex flex-wrap">{renderComponents}</div>
}
